/* eslint-disable */
// Otherwise throws invalid errors on dynamic import

import Vue from 'vue'
import Router from 'vue-router'

import home from './views/home.vue'
function redirectToExternal(to, from, next) {
    location.href = to.name;
}

function setEN(to, from, next) {
    if (localStorage.getItem(`change-language`)) {
        localStorage.removeItem(`change-language`);
    } else {
        localStorage.setItem(`language`, `en`);
    }
    next();
}

function setFR(to, from, next) {
    if (localStorage.getItem(`change-language`)) {
        localStorage.removeItem(`change-language`);
    } else {
        localStorage.setItem(`language`, `fr`);
    }
    next();
}

Vue.use(Router);

export default new Router({
    mode: `history`,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            // History back position, if user click Back button
            return savedPosition
        } else {
            // Scroll to top of page if the user didn't press the back button
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: `/`,
            name: `home`,
            component: home
        },
        {
            path: `/digital-signage`,
            name: `digital-signage-home`,
            component: () => import('./views/digital-signage/digital-signage-home.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique`,
            name: `affichage-numerique`,
            component: () => import('./views/digital-signage/digital-signage-home.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/menuboards/:section?`,
            name: `digital-signage-menuboard`,
            component: () => import('./views/digital-signage/menuboards.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/menus-restaurants/:section?`,
            name: `affichage-numerique-menus-restaurants`,
            component: () => import('./views/digital-signage/menuboards.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/videowalls/:section?`,
            name: `digital-signage-videowalls`,
            component: () => import('./views/digital-signage/videowalls.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/mur-ecrans-video/:section?`,
            name: `affichage-numerique-murs-videos`,
            component: () => import('./views/digital-signage/videowalls.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/interactive-touch-kiosk/:section?`,
            name: `digital-signage-interactive-touch-kiosk`,
            component: () => import('./views/digital-signage/interactive-touch-kiosk.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/kiosk-tactile-interactif/:section?`,
            name: `digital-signage-interactive-touch-kiosk`,
            component: () => import('./views/digital-signage/interactive-touch-kiosk.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/schools-and-education/:section?`,
            name: `digital-signage-education`,
            component: () => import('./views/digital-signage/education.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/ecoles-et-education/:section?`,
            name: `digital-signage-education`,
            component: () => import('./views/digital-signage/education.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/healthcare/:section?`,
            name: `digital-signage-healthcare`,
            component: () => import('./views/digital-signage/healthcare.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/sante-et-hopitaux/:section?`,
            name: `digital-signage-healthcare`,
            component: () => import('./views/digital-signage/healthcare.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/holograms/:section?`,
            name: `digital-signage-holograms`,
            component: () => import('./views/digital-signage/holograms.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/hologrammes/:section?`,
            name: `digital-signage-holograms`,
            component: () => import('./views/digital-signage/holograms.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/storyboard/infinite`,
            name: `digital-signage-storyboard-infinite`,
            component: () => import('./views/digital-signage/storyboard-infinite.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/storyboard/infinite`,
            name: `digital-signage-storyboard-infinite`,
            component: () => import('./views/digital-signage/storyboard-infinite.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/storyboard/download`,
            name: `digital-signage-storyboard-download`,
            component: () => import('./views/digital-signage/storyboard-download.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/storyboard/download`,
            name: `digital-signage-storyboard-download`,
            component: () => import('./views/digital-signage/storyboard-download.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/media-player/eye-infinite-player`,
            name: `digital-signage-eye-infinite-player`,
            component: () => import('./views/digital-signage/eye-infinite-player.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/logiciel-multimedia/eye-infinite-player`,
            name: `digital-signage-eye-infinite-player`,
            component: () => import('./views/digital-signage/eye-infinite-player.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/services/:section?`,
            name: `digital-signage-services`,
            component: () => import('./views/digital-signage/services.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/services/:section?`,
            name: `digital-signage-services`,
            component: () => import('./views/digital-signage/services.vue'),
            beforeEnter: setFR
        },
        {
            path: `/digital-signage/clients`,
            name: `digital-signage-clients`,
            component: () => import('./views/digital-signage/clients.vue'),
            beforeEnter: setEN
        },
        {
            path: `/affichage-numerique/clients`,
            name: `digital-signage-clients`,
            component: () => import('./views/digital-signage/clients.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/food-force-for-restaurants/:section?`,
            name: `restauration-food-force-for-restaurants`,
            component: () => import('./views/restauration/food-force-for-restaurants.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/food-force-pour-restaurants/:section?`,
            name: `restauration-food-force-pour-restaurants`,
            component: () => import('./views/restauration/food-force-for-restaurants.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/easy-self-ordering/:section?`,
            name: `restauration-self-ordering`,
            component: () => import('./views/restauration/self-ordering.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/commande-autonome/:section?`,
            name: `restauration-commande-autonome`,
            component: () => import('./views/restauration/self-ordering.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/digital-signage-for-restaurants/:section?`,
            name: `restauration-digital-menuboards`,
            component: () => import('./views/restauration/digital-signage-for-restaurants.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/affichage-numerique-pour-restaurants/:section?`,
            name: `restauration-affichage-numerique-pour-restaurants`,
            component: () => import('./views/restauration/digital-signage-for-restaurants.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/menuboard-designer/:section?`,
            name: `restauration-menuboard-designer`,
            component: () => import('./views/restauration/menuboard-designer.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/conception-et-design-menus/:section?`,
            name: `restauration-conception-et-design-menus`,
            component: () => import('./views/restauration/menuboard-designer.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/mev-srm-compatible/:section?`,
            name: `restauration-mev-srm-compatible`,
            component: () => import('./views/restauration/mev-srm-compatible.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/compatibilite-mev/:section?`,
            name: `restauration-compatibilite-mev`,
            component: () => import('./views/restauration/mev-srm-compatible.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/qr-code-and-demos/:section?`,
            name: `restauration-demonstrations`,
            component: () => import('./views/restauration/demonstrations.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/codes-qr-et-demos/:section?`,
            name: `restauration-codes-qr-et-demos`,
            component: () => import('./views/restauration/demonstrations.vue'),
            beforeEnter: setFR
        },
        {
            path: `/restauration/clients/:section?`,
            name: `restauration-clients`,
            component: () => import('./views/restauration/clients.vue'),
            beforeEnter: setEN
        },
        {
            path: `/restauration/nos-clients/:section?`,
            name: `restauration-nos-clients`,
            component: () => import('./views/restauration/clients.vue'),
            beforeEnter: setFR
        },
        {
            path: `/mobile-apps/universal-applications/:section?`,
            name: `mobile-apps-home`,
            component: () => import('./views/mobile-apps/mobile-apps-home.vue'),
            beforeEnter: setEN
        },
        {
            path: `/applications-mobiles/app-universelles/:section?`,
            name: `mobile-apps-accueil`,
            component: () => import('./views/mobile-apps/mobile-apps-home.vue'),
            beforeEnter: setFR
        },
        {
            path: `/mobile-apps/contact-tracing/:section?`,
            name: `mobile-apps-contact-tracing`,
            component: () => import('./views/mobile-apps/contact-tracing.vue')
        },
        {
            path: `/wifi/guest-social-wifi`,
            name: `wifi-guest`,
            component: () => import('./views/wifi/guest-social-wifi.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-public/wifi-public-et-social`,
            name: `wifi-public-et-social`,
            component: () => import('./views/wifi/guest-social-wifi.vue'),
            beforeEnter: setFR
        },
        {
            path: `/wifi/retail-shopping-mall/:section?`,
            name: `wifi-retail-shopping-mall`,
            component: () => import('./views/wifi/retail-shopping-mall.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-public/commerces-et-centres-commerciaux/:section?`,
            name: `wifi-commerces-et-centres-commerciaux`,
            component: () => import('./views/wifi/retail-shopping-mall.vue'),
            beforeEnter: setFR
        },
        {
            path: `/wifi/compliant-gdpr-law-25`,
            name: `compliance-gdpr-law-25`,
            component: () => import('./views/wifi/compliance-gdpr-law-25.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-public/conformite-rgpd-et-loi-25`,
            name: `wifi-rgpd-et-loi-25`,
            component: () => import('./views/wifi/compliance-gdpr-law-25.vue'),
            beforeEnter: setFR
        },
        {
            path: `/wifi/technology/:section?`,
            name: `wifi-technology`,
            component: () => import('./views/wifi/technology.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-public/technologie-et-compatibilite/:section?`,
            name: `wifi-public-technologie-et-compatibilite`,
            component: () => import('./views/wifi/technology.vue'),
            beforeEnter: setFR
        },
        {
            path: `/wifi-on-board/coaches-and-bus`,
            name: `wifi-transportation`,
            component: () => import('./views/wifi/transportation.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-a-bord/bus-et-navettes`,
            name: `wifi-a-bord-bus-et-navettes`,
            component: () => import('./views/wifi/transportation.vue'),
            beforeEnter: setFR
        },
        {
            path: `/wifi/services/:section?`,
            name: `wifi-services`,
            component: () => import('./views/wifi/services.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-public/services/:section?`,
            name: `wifi-public-services`,
            component: () => import('./views/wifi/services.vue'),
            beforeEnter: setFR
        },
        {
            path: `/wifi/clients/:section?`,
            name: `wifi-clients`,
            component: () => import('./views/wifi/clients.vue'),
            beforeEnter: setEN
        },
        {
            path: `/wifi-public/marches-et-clients/:section?`,
            name: `wifi-public-marches-et-clients`,
            component: () => import('./views/wifi/clients.vue'),
            beforeEnter: setFR
        },
        {
            path: `/shop/:option?`,
            name: `wifi-shop`,
            component: () => import('./views/wifi/shop.vue')
        },
        {
            path: `/contact`,
            name: `contact`,
            component: () => import('./views/contact'),
            beforeEnter: setEN
        },
        {
            path: `/contactez-nous`,
            name: `contactez-nous`,
            component: () => import('./views/contact'),
            beforeEnter: setFR
        },
        {
            path: `/about-us`,
            name: `about-us`,
            component: () => import('./views/about-us'),
            beforeEnter: setEN
        },
        {
            path: `/a-propos-de-nous`,
            name: `a-propos-de-nous`,
            component: () => import('./views/about-us'),
            beforeEnter: setFR
        },
        {
            path: `/blog/:section?/:id?`,
            name: `blog`,
            component: () => import('./views/blog')
        },
        {
            path: `/qr-code-generator`,
            name: `qr-code-generator`,
            component: () => import('./views/qr-code-generator.vue')
        },
        {
            path: `/terms-and-policies/:type?`,
            name: `terms-and-policies`,
            component: () => import('./views/terms-and-policies.vue'),
            beforeEnter: setEN
        },
        {
            path: `/termes-et-conditions/:type?`,
            name: `termes-et-conditions`,
            component: () => import('./views/terms-and-policies.vue'),
            beforeEnter: setFR
        },
        // Special URL for clients
        {path: `/dj-conditions`, beforeEnter: redirectToExternal, name: `https://eyeinlivestorage.blob.core.windows.net/public/wifi/terms-conditions/complexe-desjardins/conditions_utilisations.pdf`},
        {path: `/dj-confidentialite`, beforeEnter: redirectToExternal, name: `https://eyeinlivestorage.blob.core.windows.net/public/wifi/terms-conditions/complexe-desjardins/politique_confidentialite.pdf`},
        // Useful links for Documentation
        {path: `/doc/*`, beforeEnter: redirectToExternal, name: `http://doc.eye-in.com`},
        // Compatibility with October CMS website 2018
        {path: `/en`, redirect: `/?lang=en`},
        {path: `/fr`, redirect: `/?lang=fr`},
        {path: `/wifi/gdpr`, redirect: `/wifi/compliant-gdpr-law-25`},
        {path: `/wifi-board`, redirect: `/wifi-on-board/coaches-and-bus`},
        {path: `/digital-signage/education`, redirect: `/digital-signage/schools-and-education`},
        {path: `/menuboards/:section?`, redirect: `/digital-signage/menuboards`},
        {path: `/:lang?/about`, redirect: `/about-us`},
        {path: `/:lang?/blog`, redirect: `/blog`},
        {path: `/:lang/clients`, redirect: `/wifi/clients`},
        {path: `/:lang/demos`, redirect: `/`},
        {path: `/:lang?/eye-intelligence`, redirect: `/wifi/retail-shopping-mall`},
        {path: `/:lang?/wifi-crm`, redirect: `/wifi/retail-shopping-mall`},
        {path: `/:lang?/proximity-marketing`, redirect: `/wifi/retail-shopping-mall`},
        {path: `/:lang/wifi-board`, redirect: `/wifi-board`},
        {path: `/:lang?/pages/meraki_sign_up.php`, redirect: `/wifi/equipment`},
        {path: `/:lang?/eye-inspire`, redirect: `/digital-signage`},
        {path: `/:lang/digital-signage`, redirect: `/digital-signage`},
        // Menu Boards page is an exception to keep SEO
        {path: `/:lang/menuboards`, redirect: `/digital-signage/menuboards`},
        {path: `/:lang?/videowalls`, redirect: `/digital-signage/videowalls`},
        {path: `/:lang?/storyboard-lite`, redirect: `/digital-signage/storyboard/infinite`},
        {path: `/:lang?/storyboard-pro`, redirect: `/digital-signage/storyboard/download`},
        {path: `/:lang?/eye-infinite-storyboard`, redirect: `/digital-signage/storyboard/download`},
        {path: `/:lang?/eye-infinite-player`, redirect: `/digital-signage/media-player/eye-infinite-player`},
        // Compatibility with Last PHP website 2016 still referenced
        {path: `/:lang?/welcome.php`, redirect: `/`},
        {path: `/:lang?/about.php`, redirect: `/about-us`},
        {path: `/:lang?/careers.php`, redirect: `/about-us`},
        {path: `/:lang?/news.php`, redirect: `/blog`},
        {path: `/:lang?/news_meraki.php`, redirect: `/blog`},
        {path: `/:lang?/examples.php`, redirect: `/`},
        {path: `/:lang?/testimonials.php`, redirect: `/`},
        {path: `/:lang?/blog_digital_signage_strategy.php`, redirect: `/blog`},
        {path: `/:lang?/solutions_wifi.php`, redirect: `/wifi/guest-social-wifi`},
        {path: `/:lang?/news_transports.php`, redirect: `/wifi-board`},
        {path: `/:lang?/clients_transportation.php`, redirect: `/wifi-board`},
        {path: `/:lang?/solutions_digital_signage.php`, redirect: `/digital-signage`},
        {path: `/:lang?/solutions_menu_boards.php`, redirect: `/digital-signage/menuboards`},
        {path: `/:lang?/solutions_entertainment_tv.php`, redirect: `/digital-signage/menuboards`},
        {path: `/:lang?/solutions_videowalls.php`, redirect: `/digital-signage/videowalls`},
        {path: `/:lang?/storyboard_pro.php`, redirect: `/digital-signage/storyboard/download`},
        {path: `/:lang?/storyboard_lite.php`, redirect: `/digital-signage/storyboard/infinite`},
        // Other URLs but still used
        {path: `/sitemap.xml`, redirect: `/sitemap`},
        {path: `/wireless`, redirect: `/wifi/guest-social-wifi`},
        {path: `/sitemap`, noIndex: true},
        {path: `/robots.txt`, noIndex: true},
        {path: `*`, redirect: `/`}// Instead of 404 page
    ]
})
